import axios from "axios";

export const USERS_URL = "/admins/admin";

// CREATE =>  POST: add a new admin to the server
export function addAdmin(adminData) {
  return axios.post(USERS_URL, {...adminData});
}

// READ
export function getAllAdmins() {
  return axios.get(USERS_URL);
}

// UPDATE => PUT: update the admin on the server
export function updateAdmin(adminData) {
  return axios.put(`${USERS_URL}/${adminData.id}`, { ...adminData });
}

// DELETE => delete the admin from the server
export function deleteAdmin(adminId) {
  return axios.delete(`${USERS_URL}/${adminId}`);
}

